var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSyncIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 11.671V8.88379C16.6667 8.20226 16.6667 7.86148 16.5399 7.55507C16.413 7.24865 16.1721 7.00768 15.6904 6.52576L11.7433 2.57693C11.3275 2.161 11.1197 1.95304 10.8621 1.82982C10.8085 1.80419 10.7537 1.78144 10.6977 1.76168C10.4285 1.66663 10.1345 1.66663 9.54654 1.66663C6.84239 1.66663 5.4903 1.66663 4.57448 2.40534C4.38947 2.55458 4.22094 2.72318 4.07177 2.90828C3.33337 3.82448 3.33337 5.17717 3.33337 7.88253V11.671C3.33337 14.815 3.33337 16.387 4.30968 17.3638C5.09559 18.15 6.26707 18.3034 8.33337 18.3333M10.8334 2.08348V2.50032C10.8334 4.85837 10.8334 6.03739 11.5656 6.76994C12.2979 7.50249 13.4764 7.50249 15.8334 7.50249H16.25",
    stroke: "#E52333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16663 13.3333L9.99996 15C10.2021 13.5866 11.4473 12.5 12.9166 12.5C13.9078 12.5 14.7835 12.9944 15.3105 13.75M16.6666 17.5L15.8333 15.8333C15.6311 17.2468 14.386 18.3333 12.9166 18.3333C11.9255 18.3333 11.0498 17.8389 10.5227 17.0833",
    stroke: "#E52333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncIcon);
export default __webpack_public_path__ + "static/media/syncIcon.f58fe9452715cf79ee5cbd2a13308bee.svg";
export { ForwardRef as ReactComponent };